var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.325,
    height: 17.9,
    viewBox: "0 0 18.325 17.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1963",
    "data-name": "Trac\\xE9 1963",
    d: "M3.525,8.525c0-1.25.55-1.725,1.425-1.725s1.425.475,1.425,1.725v9.45c0,1.25-.55,1.725-1.425,1.725s-1.425-.475-1.425-1.725ZM.775,17.8c0,2.8,1.475,4.4,4.175,4.4s4.175-1.6,4.175-4.4V8.7c0-2.8-1.475-4.4-4.175-4.4S.775,5.9.775,8.7Zm15.575-9c0,1.875-.6,3.25-2.7,5.475C11.6,16.425,10.9,17.9,10.9,19.85V22h7.95V19.5h-5.2a1.892,1.892,0,0,1-.025-.375c0-.925.45-1.75,2.075-3.5,2.55-2.725,3.4-4.6,3.4-6.925,0-2.8-1.4-4.4-4.1-4.4s-4.1,1.6-4.1,4.4v1.7h2.6V8.525c0-1.25.55-1.725,1.425-1.725S16.35,7.225,16.35,8.8Z",
    transform: "translate(-0.775 -4.3)",
    fill: "#7fa9a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon-02.f6b43739a78849de28896c4b16b613cd.svg";
export { ForwardRef as ReactComponent };